import { SCREEN_SIZES } from 'modules/utils/screenSizes';
import { useMediaQuery } from 'react-responsive';
import { DesktopDigitalProduct } from './DigitalProduct.desktop';
import { MobileDigitalProduct } from './DigitalProduct.mobile';

export const DigitalProduct = () => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${SCREEN_SIZES.mobile})`,
  });

  if (isMobile) return <MobileDigitalProduct />;

  return <DesktopDigitalProduct />;
};
